let ga4Loaded = false;

export const setGa4Loaded = () => {
  ga4Loaded = true;
};

export const isGa4Loaded = () => ga4Loaded;
